module.exports = __webpack_public_path__ + "img/localization.392330e6.svg";